export const PanelSettingsAuditStorageId = 'PanelSettingsAuditComponent';
